function replaceTemplating(text, templates, templateProps) {
  if ((templates === null || templates === void 0 ? void 0 : templates.length) === 0 || !templates) {
    return text;
  }
  var template = templates.shift();
  var templateKey = template.replace(/{|}| /g, '');
  var newText = text;
  if (templateKey && templateProps[templateKey]) {
    newText = text.replaceAll(template, templateProps[templateKey]);
  }
  return replaceTemplating(newText, templates, templateProps);
}
export default replaceTemplating;